import React, { useEffect, useState } from 'react';

import clsx from 'clsx';

import { useNavigationStack } from '../../../context/NavigationStackContext';
import { Paths } from '../../../shared/paths';
import { IUser } from '../../../types/interfaces/user';
import Search from '../search/Search';
import { useStyles } from './UsersList.styles';
import UserSmallItem from './user-small-item/UserSmallItem';

export interface IUsersListSmallProps {
  users?: IUser[] | null;
  showSearch?: boolean;
}

export default function UsersListSmall(props: IUsersListSmallProps) {
  const { users, showSearch = false } = props;
  const { classes } = useStyles();
  const { navigate } = useNavigationStack();
  const [filterValue, setFilterValue] = useState('');
  const [filteredUsers, setFilteredUsers] = useState<IUser[]>(null);

  useEffect(() => {
    if (!users) {
      setFilteredUsers(null);
      return;
    }
    if (!filterValue) {
      setFilteredUsers(users);
    } else {
      setFilteredUsers(
        users.filter(
          (u) =>
            u.firstname?.toLowerCase().indexOf(filterValue.toLowerCase()) !==
              -1 ||
            u.lastname?.toLowerCase().indexOf(filterValue.toLowerCase()) !== -1,
        ),
      );
    }
  }, [filterValue, users]);

  function userClickHandler(u) {
    navigate(Paths.users.toUser(u.id));
  }

  return (
    <div className={clsx(classes.usersListWrapper, classes.narrowScreen)}>
      {showSearch && (
        <Search
          fullWidth
          value={filterValue}
          onChange={setFilterValue}
          className={classes.usersListSearch}
        />
      )}
      {filteredUsers?.map((u) => (
        <React.Fragment key={u.id}>
          <UserSmallItem user={u} onUserClick={userClickHandler} />
        </React.Fragment>
      ))}
    </div>
  );
}
